import React from 'react';
import RequestCalculationForm from '../RequestCalculationForm';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiContact = () => {
  const { contact } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="bg-[#ecebf2] px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[120px]">
      <div className="mx-auto grid max-w-[1240px] items-start gap-10 md:grid-cols-2 md:items-center md:gap-12 xl:gap-16">
        <GenAiReveal>
          <div className="flex flex-col items-start">
            <img
              src={contact.deco}
              alt=""
              aria-hidden
              className="mb-2 h-auto w-[120px] shrink-0 object-contain md:w-[148px] lg:w-[160px]"
            />
            <h2 className="text-[32px] font-bold leading-none text-[#0e0e0e] md:text-4xl xl:text-[48px]">
              {contact.title}
            </h2>
            <p className="mt-4 max-w-[360px] text-base leading-[1.3] text-[#2f2f2f]/80 md:text-lg">
              {contact.description}
            </p>
          </div>
        </GenAiReveal>

        <GenAiReveal
          delay={80}
          className="[&_[data-testid=discuss-task-form]]:rounded-[32px] [&_[data-testid=discuss-task-form]]:border-0 [&_[data-testid=discuss-task-form]]:p-6 [&_[data-testid=discuss-task-form]]:shadow-[0_24px_24px_rgba(0,0,0,0.12)] md:[&_[data-testid=discuss-task-form]]:p-10"
        >
          <RequestCalculationForm
            variant="inline"
            open
            onOpenChange={() => {}}
            hideHeader
            showTaskDescription={false}
            title={contact.formTitle}
            description={contact.formDescription}
            submitLabel={contact.submitLabel}
            calculatorData={{ requestType: 'gen_ai_creative' }}
          />
        </GenAiReveal>
      </div>
    </section>
  );
};

export default GenAiContact;
